import { useWhyForeverQuery } from "@framework/content/get-why-forever-card";
import React from "react";
import IconCardsSectionLoader from '@components/ui-old/loaders/why-forever-icon-cards-loader';
import { AnimatedNoContent } from "@components/other/no-content";
import Container from "@components/ui-old/container";
const IconCardsSection: React.FC = () => {
  const {
    data,
    isLoading,
    error
  } = useWhyForeverQuery();
  if (isLoading) {
    return <IconCardsSectionLoader count={8} />;
  }
  if (error || !data) {
    return <Container>
        <AnimatedNoContent />
      </Container>;
  }
  return <section className="py-8 text-neutral-900 dark:text-neutral-100 sm:py-8 lg:py-16" data-sentry-component="IconCardsSection" data-sentry-source-file="why-forever-icon-card.tsx">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid max-w-4xl lg:max-w-6xl grid-cols-1 mx-auto mt-8 text-center gap-y-4 sm:gap-x-8 sm:grid-cols-2 lg:grid-cols-4 sm:mt-8 lg:mt-20 sm:text-left">
          {data?.iconCards.map(iconCard => <div key={iconCard.id} className="relative">
              <div className="absolute -inset-1">
                <div className="w-full h-full rotate-180 opacity-30 blur-lg filter"></div>
              </div>
              <div className="relative overflow-hidden bg-white dark:bg-neutral-900 shadow-md rounded-xl border border-neutral-200 dark:border-neutral-700 h-full">
                <div className="p-4">
                  <div className="w-12 h-12 mx-auto sm:mx-0 text-neutral-400 dark:text-neutral-500">
                    <img src={iconCard.image} alt={iconCard.title} className="w-full h-full object-contain" />
                  </div>
                  <h3 className="mt-6 text-lg font-bold text-neutral-900 dark:text-neutral-100 sm:mt-10">{iconCard.title}</h3>
                  <p className="mt-4 text-sm text-neutral-600 dark:text-neutral-400">{iconCard.description}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default IconCardsSection;